export default __webpack_public_path__ + "media/google-maps.png";